module.exports = ".my-wrapper {\r\n\tmargin:0px auto;\r\n\twidth: 70%;\r\n}\r\n.my-wrapper i{\r\n\tfont-size:30px;\r\n}"